import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const StatusSchedule = () => {
  return (
    <SettingsMetaData propertyName={"Status_Schedule"} viewPropertyName={"Status"} />
  );
};
export default StatusSchedule;